(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('crm-outbound-referral-status', {
                parent: 'entity',
                url: '/crm-outbound-referral-status',
                data: {
                    authorities: [],
                    pageTitle: 'CrmOutboundReferralStatuses'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/crm-outbound-referral-status/crm-outbound-referral-statuses.html',
                        controller: 'CrmOutboundReferralStatusController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_OUTBOUND_REFERRAL_STATUS];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_OUTBOUND_REFERRAL_STATUS, access);
                }]

            })
            .state('crm-outbound-referral-status.new', {
                parent: 'crm-outbound-referral-status',
                url: '/new',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_OUTBOUND_REFERRAL_STATUS, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/crm-outbound-referral-status/crm-outbound-referral-status-dialog.html',
                            controller: 'CrmOutboundReferralStatusDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'md',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CoreService', function (CoreService) {
                                    return {
                                        name: null,
                                        id: null,
                                        corporation: CoreService.getCorporation()
                                    };
                                }]
                            }
                        }).result.then(function () {
                            $state.go('crm-outbound-referral-status', null, {reload: 'crm-outbound-referral-status'});
                        }, function () {
                            $state.go('crm-outbound-referral-status');
                        });
                    }
                }]
            })
            .state('crm-outbound-referral-status.edit', {
                parent: 'crm-outbound-referral-status',
                url: '/{id}/edit',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_OUTBOUND_REFERRAL_STATUS, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/crm-outbound-referral-status/crm-outbound-referral-status-dialog.html',
                            controller: 'CrmOutboundReferralStatusDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'md',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CrmOutboundReferralStatus', function (CrmOutboundReferralStatus) {
                                    return CrmOutboundReferralStatus.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('crm-outbound-referral-status', null, {reload: 'crm-outbound-referral-status'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            })
            .state('crm-outbound-referral-status.delete', {
                parent: 'crm-outbound-referral-status',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_OUTBOUND_REFERRAL_STATUS, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/crm-outbound-referral-status/crm-outbound-referral-status-delete-dialog.html',
                            controller: 'CrmOutboundReferralStatusDeleteController',
                            controllerAs: 'vm',
                            size: 'md',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CrmOutboundReferralStatus', function (CrmOutboundReferralStatus) {
                                    return CrmOutboundReferralStatus.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('crm-outbound-referral-status', null, {reload: 'crm-outbound-referral-status'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            });
    }
})();
